module.exports = __webpack_public_path__ + "img/logo-mini.8aef5918.svg";